"use client";

import { HomePanel } from "../../components/HomePanel";
import { useConversationsStore } from "../../store/conversationsStore";
import { useWebchatStore, Pages } from "../store";
import { useCallback, useMemo } from "react";

export function HomePage() {
  const {
    use: { deploymentWebchatSettings: webchatSettings },
  } = useConversationsStore();

  const {
    use: { storagedDeploymentConversation },
  } = useConversationsStore();

  const panels = useMemo(() => {
    const homePannels = webchatSettings?.pages?.home.panels ?? [];
    return homePannels.concat({
      allowAnonymous: true,
      visibilityRule: "no_chat_hide",
      items: [
        {
          type: "send",
          text: "Back to chat",
          disableQuery: true,
        },
      ],
    });
  }, [webchatSettings]);

  const { routeWebChatMesssage } = useHandleConversation();
  return (
    <div className="home-panel flex h-full flex-col gap-4 overflow-auto p-4">
      {panels.map((panel, index) => (
        <HomePanel
          key={index}
          panel={panel}
          storageConversationId={storagedDeploymentConversation?.uid}
          routeWebChatMesssage={routeWebChatMesssage}
        />
      ))}
    </div>
  );
}

interface RouteWebchatMessageParams {
  query?: string;
}

const useHandleConversation = () => {
  const {
    use: { storagedDeploymentConversation },
    bind: { createConversation, setPendingVisitorMessage },
  } = useConversationsStore();

  const {
    bind: { setPage },
  } = useWebchatStore();

  const storageConversationId = storagedDeploymentConversation?.uid;

  const routeWebChatMesssage = useCallback(
    (params: RouteWebchatMessageParams) => {
      setPendingVisitorMessage(params.query ?? "");
      // If conversation exists, route to message page directly
      if (storageConversationId) {
        setPage(Pages.CHAT);
        return;
      }

      createConversation().subscribe((conv) => {
        if (!conv?.uid) {
          return;
        }
        setPage(Pages.CHAT);
      });
    },
    [storageConversationId, setPendingVisitorMessage, createConversation]
  );

  return {
    routeWebChatMesssage,
  };
};
